/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_SavingInputs */

const en_link_editor_saving = /** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const es_link_editor_saving = /** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando...`)
};

const fr_link_editor_saving = /** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement...`)
};

const de_link_editor_saving = /** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gespeichert...`)
};

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const ja_link_editor_saving = en_link_editor_saving;

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const zh_link_editor_saving = en_link_editor_saving;

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const ar_link_editor_saving = en_link_editor_saving;

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const id_link_editor_saving = en_link_editor_saving;

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const it_link_editor_saving = en_link_editor_saving;

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const ru_link_editor_saving = en_link_editor_saving;

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const pt_link_editor_saving = en_link_editor_saving;

/** @type {(inputs: Link_Editor_SavingInputs) => LocalizedString} */
const ko_link_editor_saving = en_link_editor_saving;

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Link_Editor_SavingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_saving = /** @type {((inputs?: Link_Editor_SavingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_SavingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_saving(inputs)
	if (locale === "es") return es_link_editor_saving(inputs)
	if (locale === "fr") return fr_link_editor_saving(inputs)
	if (locale === "de") return de_link_editor_saving(inputs)
	if (locale === "ja") return ja_link_editor_saving(inputs)
	if (locale === "zh") return zh_link_editor_saving(inputs)
	if (locale === "ar") return ar_link_editor_saving(inputs)
	if (locale === "id") return id_link_editor_saving(inputs)
	if (locale === "it") return it_link_editor_saving(inputs)
	if (locale === "ru") return ru_link_editor_saving(inputs)
	if (locale === "pt") return pt_link_editor_saving(inputs)
	return ko_link_editor_saving(inputs)
});